<template>
  <div
    class="d-flex align-items-center justify-content-center h-100 battle-chat-cover"
  >
    <div
      v-if="
        !isBattleCompleted &&
          !isBattleJudging &&
          dynamicBattleModel.isParticipant
      "
      class="battle-cover_card-wrap"
    >
      <Panel
        :variant="['input-bg', 'rounded', 'stroked', 'stroked-gray']"
        class="battle-cover_card"
      >
        <div class="text-center">
          <template v-if="isBattleCanceled">
            <TextBlock
              :text="$t('_web_battle_cancelled', 'Battle Canceled')"
              tag="p"
            />
            <SecondaryText :size="0.75" tag="p">
              {{
                $t(
                  'web_battle_cancelled_msg',
                  `Battle finished by time restriction. Your opponent didn't start the battle.`
                )
              }}
            </SecondaryText>
          </template>
          <template v-else>
            <template v-if="!hideCountdown && countdownOptions.date">
              <TextBlock
                :text="countdownOptions.text"
                size="1.5"
                :variant="'bold'"
                tag="p"
                class="mb-0 secondary-font"
              />
              <Countdown
                :date="countdownOptions.date"
                :separator="' : '"
                :variant="'muted'"
                class="mb-0"
              />
            </template>
            <template v-if="!hideActions && canFinishBattle">
              <TextBlock v-if="didICompleteBattle" :text="finishedBattleText" />
              <Btn
                v-else
                :label="$$t('Finish Battle')"
                class="btn-primary m-4"
                :loading="finishBattleLoading"
                @click="finishCurrentBattle"
              />
            </template>
            <template v-if="!hideActions && canStartBattle">
              <TextBlock
                v-if="didIStartBattle && !didOpponentStartBattle"
                :text="waitingOpponentText"
              />
              <Btn
                v-if="!didIStartBattle"
                :label="$$t('Start Battle')"
                :loading="startBattleLoading"
                class="btn-primary m-4"
                @click="startCurrentBattle"
              />
            </template>
            <template v-if="!hideActions && shouldConfirmResults">
              <TextBlock
                :text="
                  $$t(
                    'You have results that not matched. Your scores will be provided for judging by PLAYHERA administrator. You will get the notification with battle results',
                    'results-not-matched'
                  )
                "
                :size="0.75"
                tag="p"
                class="mb-2"
              />
              <Btn
                :label="$$t('Confirm Battle')"
                class="btn-primary"
                :loading="confirmBattleLoading"
                @click="confirmBattleResults"
              />
            </template>
            <!-- <router-link
              v-if="canProvideResults"
              :to="{
                name: 'results',
                query: {
                  ...$route.query,
                  modal: 'ProvideBattleResults',
                  round: 0,
                },
              }"
            >
              <Btn :label="$$t('Provide Results')" class="btn-primary" />
            </router-link> -->
          </template>
        </div>
        <div
          v-if="
            (dynamicBattleModel.myIndex !== null &&
              dynamicBattleModel.battleInfo) ||
              dynamicBattleModel.isHost
          "
          class="battle-cover_room-id d-flex align-items-center justify-content-center pt-3 mt-3"
        >
          <div v-if="!hideRoom" class="position-relative w-50">
            <template v-if="!dynamicBattleModel.isHost">
              <SecondaryText :text="$$t('Room ID')" tag="p" class="mb-0" />
              <TextBlock
                :text="dynamicBattleModel.battleInfo"
                tag="p"
                class="mb-0"
              />
            </template>
            <HeraInput
              v-else
              v-model="roomId"
              :label="$$t('Input room ID')"
              :placeholder="
                $t('_web_battle_room-placeholder', 'Provide room ID')
              "
              @keyup.enter.native="saveRoomId"
            />
            <AppIcon
              name="copy"
              :width="16"
              class="battle-cover_room-id-copy cursor-pointer position-absolute"
              @click="copyRoomId"
            />
          </div>
          <Btn
            v-if="!hideRoom && dynamicBattleModel.isHost"
            :label="$$t('Save')"
            :disabled="isSaveRoomDisabled"
            class="h-ml-4 btn-accent-border align-self-end"
            @click="saveRoomId"
          />
        </div>
        <div v-if="!isBattleRoyale" class="d-flex  justify-content-center">
          <Btn
            :label="$$t('Start chat')"
            :icon="'chat-group'"
            :icon-size="24"
            :loading="startBattleLoading"
            class="btn-accent-border start-chat m-4"
            @click="openPopoverChat($event)"
          />
          <Btn
            :label="$$t('Start chat')"
            :icon="'chat-group'"
            :icon-size="24"
            :loading="startBattleLoading"
            class="btn-accent-border start-chat-sm m-4"
            @click="openChat($event)"
          />
        </div>
      </Panel>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
import { BATTLE_STATUSES, POSSIBLE_RESULTS } from '@/constants/battles';
import { BLOCK_TYPES } from '@/constants/tournaments';
import { translate } from '@/mixins/translate';
import TextBlock from '@/components/atoms/TextBlock.vue';
import SecondaryText from '@/components/atoms/SecondaryText';
import Panel from '@/components/atoms/Panel.vue';
import Countdown from '@/components/common/Countdown.vue';
import HeraInput from '@/components/atoms/form/HeraFormTextInput';
import Btn from '@/components/atoms/HeraFormBtn.vue';
import AppIcon from '@/components/atoms/Icon';
import { copyToClipboard } from '@/utils';
import { isNull } from '@/utils/lodashUtils';

export default {
  name: 'BattleStatusPanel',
  components: {
    Btn,
    Panel,
    AppIcon,
    Countdown,
    HeraInput,
    TextBlock,
    SecondaryText,
  },
  mixins: [translate('_web_battle')],
  props: {
    hideCountdown: {
      type: Boolean,
      default: false,
    },
    hideRoom: {
      type: Boolean,
      default: false,
    },
    hideActions: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      roomId: '',
      interval: null,
      currentDate: Date.now() / 1e3,
      finishBattleLoading: false,
      startBattleLoading: false,
      confirmBattleLoading: false,
      statuses: {
        [BATTLE_STATUSES.started]: this.$$t('In Progress'),
        [BATTLE_STATUSES.pending]: this.$$t('Pending'),
        [BATTLE_STATUSES.completed]: this.$$t('Completed'),
        [BATTLE_STATUSES.scheduled]: this.$$t('Scheduled'),
        [BATTLE_STATUSES.cancelled]: this.$$t('Cancelled'),
        [BATTLE_STATUSES.judging]: this.$$t('Judging'),
      },
    };
  },
  computed: {
    ...mapState('my', {
      myAccountId: 'accountId',
      myAccount: 'account',
    }),
    ...mapGetters([
      'dynamicBattleModel',
      'platformByID',
      'gameByID',
      'resultsByMatchId',
    ]),
    isBattleCanceled() {
      return this.dynamicBattleModel.status === BATTLE_STATUSES.cancelled;
    },
    isBattleCompleted() {
      return this.dynamicBattleModel.status === BATTLE_STATUSES.completed;
    },
    isBattleJudging() {
      return this.dynamicBattleModel.status === BATTLE_STATUSES.judging;
    },
    isBattleStarted() {
      return this.dynamicBattleModel.status === BATTLE_STATUSES.started;
    },
    isSaveRoomDisabled() {
      return this.roomId === this.dynamicBattleModel.battleInfo;
    },
    isBattleRoyale() {
      return this.dynamicBattleModel.type === BLOCK_TYPES.BATTLE_ROYALE;
    },
    canStartBattle() {
      return (
        this.dynamicBattleModel.status === BATTLE_STATUSES.pending &&
        this.dynamicBattleModel.canManageBattle
      );
    },
    canFinishBattle() {
      return (
        !this.shouldConfirmResults &&
        this.isBattleStarted &&
        this.dynamicBattleModel.canManageBattle &&
        this.minimumResultsProvided.length >= this.playerResults.length / 2
      );
    },
    shouldConfirmResults() {
      return (
        this.dynamicBattleModel.shouldConfirm &&
        !this.dynamicBattleModel.players[this.playerIndex].confirmed
      );
    },
    canProvideResults() {
      return (
        !this.shouldConfirmResults &&
        this.isBattleStarted &&
        this.dynamicBattleModel.canManageBattle &&
        this.minimumResultsProvided.length <= this.playerResults.length / 2
      );
    },
    didICompleteBattle() {
      return this.dynamicBattleModel.players[this.playerIndex].completed;
    },
    didOpponentCompleteBattle() {
      return this.dynamicBattleModel.players[this.opponentIndex].completed;
    },
    didIStartBattle() {
      return this.dynamicBattleModel.players[this.playerIndex].started;
    },
    didOpponentStartBattle() {
      return this.dynamicBattleModel.players[this.opponentIndex].started;
    },
    waitingOpponentText() {
      return this.dynamicBattleModel.isBetweenClans
        ? this.$$t('Waiting for opponent team')
        : this.$$t('Waiting for opponent');
    },
    finishedBattleText() {
      return this.didOpponentCompleteBattle
        ? this.$$t('You finished battle')
        : this.waitingOpponentText;
    },
    //finding out for which clan user is belong(player1 || player2)
    countdownOptions() {
      let text = '',
        date;
      switch (this.dynamicBattleModel.status) {
        case BATTLE_STATUSES.scheduled:
          text = this.$$t('Battle will start');
          date = this.dynamicBattleModel.activationDate;
          break;
        case BATTLE_STATUSES.pending:
          text = this.$$t('Start battle in next');
          date = this.dynamicBattleModel.startDate;
          break;
        case BATTLE_STATUSES.started:
          text = this.$$t('Provide results in next');
          date = this.dynamicBattleModel.endDate;
          break;
      }
      date = date && this.currentDate < date ? date : null;
      return { text, date };
    },
    platform() {
      return this.platformByID(this.dynamicBattleModel.platform) || {};
    },
    game() {
      return this.gameByID(this.dynamicBattleModel.game) || {};
    },
    playerIndex() {
      return this.dynamicBattleModel.myIndex;
    },
    opponentIndex() {
      return this.playerIndex - 1 ? 1 : 2;
    },
    playerResults() {
      return this.$lodash.get(
        this.resultsByMatchId(this.dynamicBattleModel.id),
        `player_${this.playerIndex}_match_results`,
        []
      );
    },
    minimumResultsProvided() {
      return this.playerResults.filter(
        item => !isNull(item.player_1_scored) && !isNull(item.player_2_scored)
      );
    },
  },
  created() {
    this.roomId = this.dynamicBattleModel.battleInfo;
    //TODO think about changing to requestAnimationFrame
    this.interval = setInterval(
      () => (this.currentDate = Date.now() / 1e3),
      1000
    );
    this.getBattleResults({
      battleID: this.dynamicBattleModel.id,
      rounds:
        this.dynamicBattleModel.numberOfRounds ||
        this.dynamicBattleModel.numberOfMatches,
    }).catch(this.errorNotify);
    this.toggleBattleSubscriber();
  },
  destroyed() {
    clearInterval(this.interval);
    this.toggleBattleSubscriber(true);
  },
  methods: {
    ...mapActions([
      'confirmResults',
      'startBattle',
      'finishBattle',
      'updateBattleInfo',
      'errorNotify',
      'getBattleResults',
      'addSystemSubscriber',
      'removeSystemSubscriber',
      'getConversationInfo',
    ]),
    ...mapMutations([
      'updateBattleModel',
      'updateBattleFromSubscriber',
      'setActivePopoverChat',
      'showPopoverChat',
    ]),
    getWinLoseText(result) {
      return result === POSSIBLE_RESULTS.techWin
        ? this.$$t('Win', 'win')
        : result === POSSIBLE_RESULTS.techLoss
        ? this.$$t('Lose', 'lose')
        : null;
    },
    copyRoomId() {
      copyToClipboard(this.roomId || this.dynamicBattleModel.battleInfo);
    },
    saveRoomId() {
      if (this.isSaveRoomDisabled) {
        return;
      }
      this.updateBattleInfo({
        battleId: this.dynamicBattleModel.id,
        battleInfo: this.roomId,
      }).catch(error => this.errorNotify(error));
    },
    startCurrentBattle() {
      this.startBattleLoading = true;
      this.startBattle(this.dynamicBattleModel.id)
        .then(() => {
          const players = this.$lodash.cloneDeep(
            this.dynamicBattleModel.players
          );
          players[this.playerIndex].started = true;
          this.updateBattleModel({ players });
        })
        .catch(this.errorNotify)
        .finally(() => (this.startBattleLoading = false));
    },
    finishCurrentBattle() {
      this.finishBattleLoading = true;
      this.finishBattle(this.dynamicBattleModel.id)
        .then(() => {
          const players = this.$lodash.cloneDeep(
            this.dynamicBattleModel.players
          );
          players[this.playerIndex].completed = true;
          this.updateBattleModel({ players });
        })
        .catch(this.errorNotify)
        .finally(() => (this.finishBattleLoading = false));
    },
    confirmBattleResults() {
      this.confirmBattleLoading = true;
      this.confirmResults({
        battleID: this.dynamicBattleModel.id,
      })
        .catch(this.errorNotify)
        .finally(() => (this.confirmBattleLoading = false));
    },
    toggleBattleSubscriber(remove = false) {
      if (remove) {
        this.removeSystemSubscriber(this.subscriber);
      } else {
        this.addSystemSubscriber(this.subscriber);
      }
    },
    subscriber(data) {
      this.updateBattleFromSubscriber({
        battleId: this.dynamicBattleModel.id,
        myId: this.myAccountId,
        data,
      });
    },
    openChat(event) {
      if (!event.ctrlKey) {
        var login = this.dynamicBattleModel.players[
          this.dynamicBattleModel.myIndex === 0 ? 1 : 0
        ].captain;
      }
      this.getConversationInfo({ conversationId: login })
        .then(() => {
          window.dataLayer.push({
            event: 'tournament chat',
            from: this.$route.path,
            gameId: this.dynamicBattleModel.tournament.game,
            tournamentId: this.dynamicBattleModel.tournament._id,
            tournamentName: this.dynamicBattleModel.tournament.title,
            squadSize: this.dynamicBattleModel.squad,
            round: this.dynamicBattleModel.round,
            stage: this.dynamicBattleModel.stageId,
            userID: this.myAccount._id,
            gameName: this.dynamicBattleModel.tournament.game,
            tournamentCountry: this.dynamicBattleModel.tournament.country,
            tournamentPool: this.dynamicBattleModel.tournament.prize.prize_pool,
            regForm: this.dynamicBattleModel.tournament
              .requiresRegistrationForm,
            tournamentPrivate:
              this.dynamicBattleModel.tournament.registrationType === 'closed'
                ? 'true'
                : 'false',
            tournamentOrganizer: this.dynamicBattleModel.tournament
              .eventOrganizerName,
          });
        })
        .then(res => {
          this.$router.push({
            name: 'conversations',
            params: {
              id: res.id,
            },
          });
        })

        .catch(err => {
          this.errorNotify(err);
          this.$router.push({
            name: 'conversations',
          });
        });
    },
    openPopoverChat(event) {
      if (!event.ctrlKey) {
        this.showPopoverChat();
        var login = this.dynamicBattleModel.players[
          this.dynamicBattleModel.myIndex === 0 ? 1 : 0
        ].captain;

        this.getConversationInfo({ conversationId: login })
          .then(() => {
            window.dataLayer.push({
              event: 'tournament chat',
              from: this.$route.path,
              gameId: this.dynamicBattleModel.tournament.game,
              tournamentId: this.dynamicBattleModel.tournament._id,
              tournamentName: this.dynamicBattleModel.tournament.title,
              squadSize: this.dynamicBattleModel.squad,
              round: this.dynamicBattleModel.round,
              stage: this.dynamicBattleModel.stageId,
              userID: this.myAccount._id,
              gameName: this.dynamicBattleModel.tournament.game,
              tournamentCountry: this.dynamicBattleModel.tournament.country,
              tournamentPool: this.dynamicBattleModel.tournament.prize
                .prize_pool,
              regForm: this.dynamicBattleModel.tournament
                .requiresRegistrationForm,
              tournamentPrivate:
                this.dynamicBattleModel.tournament.registrationType === 'closed'
                  ? 'true'
                  : 'false',
              tournamentOrganizer: this.dynamicBattleModel.tournament
                .eventOrganizerName,
            });
          })
          .then(res => {
            this.setActivePopoverChat(res.id);
          })

          .catch(this.errorNotify);
        event.preventDefault();
      }
    },
  },
};
</script>

<style lang="scss">
.battle-chat-cover {
  .battle-cover_card-wrap {
    width: 464px;
  }

  &_status {
    font-size: 1rem;
    background: linear-gradient(
      270deg,
      rgba(255, 255, 255, 0) 12.72%,
      rgba(255, 255, 255, 0.3) 50.28%,
      rgba(255, 255, 255, 0) 87.87%
    );
  }
  &_card {
    flex-basis: 292px;
  }
  &_room-id {
    // border-top: 1px dashed $ph-secondary-text;
    .btn {
      min-width: 4rem;
    }
  }
  &_room-id-copy {
    top: 0;
    @include auto-rtl(right, 0);
  }
  &_draw {
    background-color: $ph-secondary-text;
    border-radius: 2rem;
  }
}
.start-chat-sm {
  display: none;
}
@media (max-width: 767px) {
  .start-chat-sm {
    display: block;
  }
  .start-chat {
    display: none;
  }
}
</style>
